/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import NoteResponse from './NoteResponse';

/**
* The SearchNotesResponse model module.
* @module model/SearchNotesResponse
* @version 2020-12-7
*/
export default class SearchNotesResponse {
    /**
    * Constructs a new <code>SearchNotesResponse</code>.
    * 通知検索レスポンス
    * @alias module:model/SearchNotesResponse
    * @class
    * @param notes {Array.<module:model/NoteResponse>} 通知
    * @param result {module:model/SearchNotesResponse.ResultEnum} 
    */

    constructor(notes, result) {
        
        
        this['notes'] = notes;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>SearchNotesResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SearchNotesResponse} obj Optional instance to populate.
    * @return {module:model/SearchNotesResponse} The populated <code>SearchNotesResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchNotesResponse();
                        
            
            if (data.hasOwnProperty('notes')) {
                obj['notes'] = ApiClient.convertToType(data['notes'], [NoteResponse]);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * 通知
    * @member {Array.<module:model/NoteResponse>} notes
    */
    'notes' = undefined;
    /**
    * @member {module:model/SearchNotesResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
